var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Lista de requisitos")]),_vm._l((_vm.listaRequisitos),function(v,i){return _c('app-upload-file',{key:i,attrs:{"requisite":v},on:{"changed":(e) => _vm.onChanged(e, i)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }